import axios from "axios";
const getPackagesApi = async (
  callback,
  packagesResData,
  lang,
  baseURL,
  loading
) => {
  loading(true);

  try {
    const response = await axios.get(`${baseURL}/website/packages`, {
      headers: {
        Accept: "application/json",
        lang: lang,
      },
    });
    // console.log(data);
    packagesResData(response.data.sectionTitle);
    callback(response.data.data);
    loading(false);
    return;
  } catch (error) {
    loading(false);
    throw new Error(error);
  }
};

export default getPackagesApi;
